<template>
  <vs-popup 
    fullscreen 
    :title="editorMode + ' Editor'" 
    :active.sync="popupActive" 
    v-if="popupActive"
  >
    <vs-tabs v-model="activeTab">
      <vs-tab label="Properties" style="height:600px">
        <MonacoEditor 
          key="prop" 
          ref="monacoEditor" 
          suffix="prop" 
          :text_value="propValue"
          :language="editorLanguage"
        />
      </vs-tab>
      <vs-tab 
        v-if="editorMode === 'Metadata'" 
        label="Advanced properties" 
        style="height:600px"
      >
        <MonacoEditor 
          key="code" 
          suffix="code" 
          ref="monacoCodeEditor" 
          :text_value="codeValue"
          language="json"
        />
      </vs-tab>
    </vs-tabs>
    <div style="margin-left:10px;">
      <vs-button 
        color="dark" 
        v-if="activeTab === '0'" 
        @click="onCopyProp" 
        style="float:left" 
        type="line" 
        icon-pack="feather" 
        icon="icon-copy" 
        icon-after
      />
      <vs-button 
        color="dark" 
        v-if="activeTab === '1'" 
        @click="onCopyCode" 
        style="float:left" 
        type="line" 
        icon-pack="feather" 
        icon="icon-copy" 
        icon-after
      />
      <vs-button 
        color="dark" 
        v-if="editorMode === 'HTML'" 
        @click="onSaveHTML" 
        style="float:left" 
        type="line" 
        icon-pack="feather" 
        icon="icon-save" 
        icon-after
      />
      <vs-button 
        color="dark" 
        v-if="editorMode === 'Metadata' && activeTab === '0'" 
        @click="onSaveMetadata" 
        style="float:left" 
        type="line" 
        icon-pack="feather" 
        icon="icon-save" 
        icon-after
      />
      <vs-button 
        color="dark" 
        v-if="editorMode === 'Metadata' && activeTab === '1'" 
        @click="onSaveCodeStep" 
        style="float:left" 
        type="line" 
        icon-pack="feather" 
        icon="icon-save" 
        icon-after
      />
    </div>
  </vs-popup>
</template>

<script>
import MonacoEditor from '../MonacoEditor.vue'

export default {
  name: 'AdvancedPropertiesPopup',
  
  components: {
    MonacoEditor
  },

  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    editorMode: {
      type: String,
      required: true
    },
    propValue: {
      type: String,
      default: ''
    },
    codeValue: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      activeTab: '0'
    }
  },

  computed: {
    popupActive: {
      get() {
        return this.isActive
      },
      set(value) {
        this.$emit('update:isActive', value)
      }
    },
    editorLanguage() {
      return this.editorMode === 'HTML' ? 'html' : 'json'
    }
  },

  methods: {
    onCopyProp() {
      this.$emit('copy-prop', this.$refs.monacoEditor.getValue())
    },

    onCopyCode() {
      this.$emit('copy-code', this.$refs.monacoCodeEditor.getValue())
    },

    onSaveHTML() {
      this.$emit('save-html', this.$refs.monacoEditor.getValue())
    },

    onSaveMetadata() {
      this.$emit('save-metadata', this.$refs.monacoEditor.getValue())
    },

    onSaveCodeStep() {
      this.$emit('save-code-step', this.$refs.monacoCodeEditor.getValue())
    }
  }
}
</script> 